// @ts-check
/**
 * @prettier
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _values from 'lodash/values';
import { ButtonV2 } from '@zola/zola-ui';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addItemV2 } from '../../../../../../actions/CartActions';
import { priceFormatter } from '../../../../../../components/product/PricingUtils';

// @ts-ignore
import styles from './ShopItemCard.module.less';
// @ts-ignore
import icons from '../icons.module.less';

const ShopItemCardActionItems = ({
  inputValue,
  onInputChange,
  onAddToCartclick,
  disabled,
  stockMessage,
}) => {
  return (
    <div className={styles.actionsContainer}>
      {!disabled && (
        <div className={styles.amountInputContainer}>
          <input
            className={styles.numericInput}
            type="number"
            min={1}
            max={100}
            value={inputValue}
            onChange={onInputChange}
          />
        </div>
      )}
      <div className={styles.addToCartButtonContainer}>
        <ButtonV2 disabled={disabled} onClick={onAddToCartclick} className={styles.addToCartButton}>
          {stockMessage || 'Add To Cart'}
        </ButtonV2>
      </div>
    </div>
  );
};

const ShopItemCardActions = ({
  isAddedToCart,
  isAddingToCart,
  inputValue,
  handleInputChange,
  handleInputAddtoCartClick,
  addToCartAction,
  stockMessage,
}) => {
  if (isAddedToCart)
    return (
      <div className={styles.addedToCartMessage}>
        <i className={icons.check} />
        &nbsp;Added {inputValue} to Cart
      </div>
    );
  if (isAddingToCart) return <div className={styles.addedToCartMessage}>Adding To Cart...</div>;
  return (
    <ShopItemCardActionItems
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onAddToCartclick={handleInputAddtoCartClick}
      disabled={addToCartAction.disabled}
      stockMessage={stockMessage}
    />
  );
};

/**
 * Shop item card
 * @param {Object} props
 * @param {Object} props.card - Item/Product to display
 * @param {(item: {sku: string, totalCents: number}) => void} props.onItemAddedToCart - Event handler after an item is added to the cart
 * @param {Function} props.onAddItemToCart - Redux function to add an item to the shopping cart
 */
const ShopItemCard = ({ card, onItemAddedToCart, onAddItemToCart }) => {
  const [inputValue, setInputValue] = useState(1);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [isAddedToCart, setIsAddedToCart] = useState(false);

  const {
    name,
    default_sku_id: sku,
    brand: { name: brandName },
    product_look_views: productLookViews,
  } = card;

  const [productLookView] = productLookViews;
  const [skuPreview] = productLookView.sku_previews;

  const handleInputChange = e => setInputValue(e.target.value);

  const handleInputAddtoCartClick = () => {
    setIsAddingToCart(true);
    return onAddItemToCart({
      sku_id: sku,
      quantity: inputValue,
      item_origin: 'WEDDINGS',
    })
      .then(response => {
        setIsAddingToCart(false);
        if (response.status === 'error') {
          setInputValue(response.trigger);
        } else {
          setIsAddedToCart(true);
          onItemAddedToCart({
            sku,
            // @ts-ignore
            totalCents: skuPreview.price_cents * parseInt(inputValue, 10),
          });
        }
      })
      .catch(() => {
        setIsAddingToCart(false);
      });
  };

  return (
    <div className={styles.card}>
      <img
        className={styles.image}
        src={_values(productLookView.images[0].aspect_ratios)[0].medium}
        alt={name}
      />
      <div className={styles.shopItemText}>
        <span className={styles.title}>{brandName}</span>
        <p className={styles.description}>{name}</p>
      </div>
      <p className={styles.price}>{priceFormatter(skuPreview.price_cents / 100)}</p>
      <p className={styles.freeShipping}>{skuPreview.free_shipping ? `Free Shipping` : ''}</p>
      <ShopItemCardActions
        isAddedToCart={isAddedToCart}
        isAddingToCart={isAddingToCart}
        inputValue={inputValue}
        handleInputChange={handleInputChange}
        handleInputAddtoCartClick={handleInputAddtoCartClick}
        addToCartAction={skuPreview.actions.filter(a => a.key === 'ADD_TO_CART')[0]}
        stockMessage={skuPreview.stock_message}
      />
    </div>
  );
};

ShopItemCard.propTypes = {
  card: PropTypes.shape({}).isRequired,
  onAddItemToCart: PropTypes.func.isRequired,
  onItemAddedToCart: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onAddItemToCart: addItemV2,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(ShopItemCard);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/WeddingShopItemsModal/components/ShopItemCard.jsx